import {
  API_KEY_LIST_REQUEST,
  API_KEY_LIST_SUCCESS,
  API_KEY_LIST_FAIL,
  API_KEY_CREATE_REQUEST,
  API_KEY_CREATE_SUCCESS,
  API_KEY_CREATE_FAIL,
  API_KEY_CREATE_RESET,
  API_KEY_DELETE_REQUEST,
  API_KEY_DELETE_SUCCESS,
  API_KEY_DELETE_FAIL,
} from '../constants/apiKeyConstants';
import { USER_LOGOUT } from '../constants/userConstants';

export const apiKeyListReducer = (state = { apiKeys: [] }, action) => {
  switch (action.type) {
    case API_KEY_LIST_REQUEST:
      return { loading: true, apiKeys: [] };
    case API_KEY_LIST_SUCCESS:
      return { loading: false, apiKeys: action.payload };
    case API_KEY_LIST_FAIL:
      return { loading: false, error: action.payload };
    case USER_LOGOUT:
      return { apiKeys: [] };
    default:
      return state;
  }
};

export const apiKeyCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case API_KEY_CREATE_REQUEST:
      return { loading: true };
    case API_KEY_CREATE_SUCCESS:
      return { loading: false, success: true, apiKey: action.payload };
    case API_KEY_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case API_KEY_CREATE_RESET:
      return {};
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const apiKeyDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case API_KEY_DELETE_REQUEST:
      return { loading: true };
    case API_KEY_DELETE_SUCCESS:
      return { loading: false, success: true };
    case API_KEY_DELETE_FAIL:
      return { loading: false, error: action.payload };
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};